// 课堂派活动项目路由

export default [
    {
      path: '/ShareLive',
      name: '直播分享',
      // meta: { keepAlive: true },
      component: () => import(/* webpackChunkName: "ShareLive" */ '@/views/KtpActivity/ShareLive/index.vue')
    },
    {
      path: '/ShareClass',
      name: '课程分享',
      // meta: { keepAlive: true },
      component: () => import(/* webpackChunkName: "ShareClass" */ '@/views/KtpActivity/shareClass/index.vue')
    },
    {
      path: '/ProductDynamic',
      name: '产品动态',
      // meta: { keepAlive: true },
      component: () => import(/* webpackChunkName: "ShareClass" */ '@/views/KtpActivity/productDynamic/index.vue')
    },
    {
      path: '/ProductDynamicDetail',
      name: '产品动态详情',
      // meta: { keepAlive: true },
      component: () => import(/* webpackChunkName: "ShareClass" */ '@/views/KtpActivity/productDynamic/detail.vue')
    },
    {
      path: '/helpCenter',
      name: '帮助中心',
      // meta: { keepAlive: true },
      component: () => import(/* webpackChunkName: "ShareClass" */ '@/views/KtpActivity/helpCenter/index.vue')
    },
    {
      path: '/smallProgram',
      name: '点击前往小程序',
      component: () => import(/* webpackChunkName: "ShareClass" */ '@/views/KtpActivity/ad/smallProgram.vue')
    },
    {
      path: '/helpCenterDetail',
      name: '帮助中心详情',
      // meta: { keepAlive: true },
      component: () => import(/* webpackChunkName: "ShareClass" */ '@/views/KtpActivity/helpCenter/detail.vue')
    },
    {
      path: '/helpCenterSearch',
      name: '搜索',
      // meta: { keepAlive: true },
      component: () => import(/* webpackChunkName: "ShareClass" */ '@/views/KtpActivity/helpCenter/search.vue')
    },
    {
      path: '/feedBack',
      name: '意见反馈',
      // meta: { keepAlive: true },
      component: () => import(/* webpackChunkName: "ShareClass" */ '@/views/KtpActivity/feedBack/index.vue')
    },
]